// extracted by mini-css-extract-plugin
export var actionIcon = "_q7-0";